import React from 'react';

const FullPageLoader = () => {
	return (
		<div style={styles.overlay}>
			<div style={styles.spinner} />
		</div>
	);
};

const styles: any = {
	overlay: {
		height: '100vh',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: '#ffffff',
	},
	spinner: {
		width: '50px',
		height: '50px',
		border: '5px solid #e5e7eb',
		borderTop: '5px solid #2563eb',
		borderRadius: '50%',
		animation: 'spin 1s linear infinite',
	},
};

export default FullPageLoader;
